function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Nighttime_electricity_metering"
}, /*#__PURE__*/React.createElement("path", {
  d: "M269.3 49.4V0H241v49.4h-35.4V0h-28.3v49.4H163v25.9c0 28.2 19.7 51.7 46.1 57.7v150.5h28.3V133c26.4-6 46.1-29.5 46.1-57.7V49.4h-14.2zM127.6 102.3c-13-6.7-27.8-10.2-42.5-10.2-42.5 0-85 28.5-85 81.5s42.5 81.5 85 81.5c14.8 0 29.5-3.4 42.5-10.2 24.4-12.6 42.5-36.8 42.5-71.3s-18.1-58.7-42.5-71.3zM85 227.5c-15.2 0-30-5.2-40.4-14.2-11.3-9.7-17-23.1-17-39.7s5.7-30 17-39.7c10.4-9 25.2-14.2 40.4-14.2 6 0 12 .8 17.6 2.4C91.8 135.2 85 152.5 85 173.6s6.8 38.4 17.6 51.5c-5.6 1.6-11.5 2.4-17.6 2.4z"
}))));